<template>
    <div class="the-navbar__user-meta flex items-center" style="position: absolute; right:0;">
        <!-- <div class="text-right leading-tight hidden sm:block"> -->
        <!-- <p class="font-semibold">{{ userName }}</p> -->
        <!-- <small>Available</small> -->

        <li class="flex px-5 cursor-pointer" @click="logOut">
            <div class="con-img ml-3 mt-1">
                <vs-avatar class="w-5 h-5 " />
            </div>
            <span class="ml-2 mt-2 mr-1"> {{ userName }}</span>
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
        </li>
        <!-- </div> -->
        <!-- <vs-avatar class="m-0" size="35px" /> -->
        <!-- <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer"> -->
        <!-- <div class="con-img ml-3" style="border:1px solid #ccc;">
                <vs-avatar class="m-0" size="35px" />
            </div>

            <vs-dropdown-menu class="vx-navbar-dropdown">
                <ul style="min-width: 4rem"> -->
        <!--
                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">Profile</span>
                    </li>

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">Inbox</span>
                    </li>

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">Tasks</span>
                    </li>

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">Chat</span>
                    </li>

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">Wish List</span>
                    </li>

                    <vs-divider class="m-1" /> -->

        <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logOut">
                        <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">Logout</span>
                    </li>
                </ul> -->
        <!-- </vs-dropdown-menu>
        </vs-dropdown> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            userName: '',
        };
    },
    computed: {
        activeUserInfo() {
            return this.$store.state.AppActiveUser;
        },
    },
    methods: {
        // logout() {
        //     localStorage.removeItem('userInfo');

        //     // This is just for demo Purpose. If user clicks on logout -> redirect
        //     this.$router.push('/pages/login').catch(() => {});
        // },
        async logOut() {
            await this.$store.dispatch('logoutUser');
            // this.$router.push('');
            location.href = '/';
        },
    },
    mounted() {
        this.userName = this.$store.getters.getUSERNAME;
    },
};
</script>
